{
  "note": "Hand-authored in public/bike-align.html for the 12-frame 'quick' mount. Per-frame X offset (px) of the rider clip from the standalone-bike floor anchor (origin 0.5,1); oy shared. pedal matches the mount's final offset so the loop does not jump.",
  "riderScale": 0.33,
  "standaloneW": 45,
  "oy": 11,
  "mount": [-41, -36, -32, -26, -21, -17, -14, -10, -7, -5, -4, -4],
  "pedal": [-4, -4, -4, -4, -4, -4, -4, -4, -4, -4, -4, -4, -4]
}
